import { requestWithToken as request } from "./api";

export const getCarteraAnalista = () =>
    request.get(
        `/analyst_view/get_all/`
    );

export function getUploadedFiles(company_id, file_id, page) {
    const result = request.get(
        `/analyst_view/${company_id}/all_uploads/?page=${page}&file_id=${file_id}`
    );
    return result;
}

export const allAnalysts = () =>request.get(`/analyst_view/analysts_list/`);
export const allCompanies = () =>request.get(`/analyst_view/companies_list/`);
export function saveCartera(company_id, old_analists, new_analists, deleted_analists) {
    const param = {
        'old_analists': old_analists,
        'new_analists': new_analists,
        'deleted_analists': deleted_analists
    };
    return request.post(`/analyst_view/${company_id}/save_cartera/`, param);
}

export const getDetalleCompania = (id) =>
    request.get(
        `/analyst_view/${id}/complementary_data/`
    );

export const getFileData = (id) =>
    request.get(
        `/analyst_view/${id}/file_data/`
    );

export const getFirstRows = (id) =>
    request.get(
        `/analyst_view/${id}/load_first_rows/`
    );

export const grabarConfiguracion = (id, params = {}) => {
    return request.post(`/analyst_view/${id}/save_configuration/`,
        params)
    }

export const toggleFile = (id, toggle, company) => {
    const params = { 'toggle': toggle, 'company': company }
    return request.post(`/analyst_view/${id}/toggle_file/`, params);
}

export const sendEmailDocs = (company, userid, which) => {
    const params = { 'userid': userid, 'which': which }
    return request.post(`/analyst_view/${company}/send_email_docs/`, params);
}

export const updateGeneralBookSheetId = (id_drive_file, company_id) =>
    request.post("/analyst_view/update_general_book_drive_id/", { id_drive_file, company_id });

export const getUsersByCompany = (company_id) =>
    request.get(`/analyst_view/${company_id}/users_by_company/`, {});

export const updateUserOperations = (company_id, userOps) =>
    request.post(`/analyst_view/${company_id}/update_user_operations/`, userOps);

